import styled from 'styled-components';

export const Container = styled.div`
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin: 8px 0;
    padding: 8px;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors['Level 1']};
    ${({ theme }) => theme.typography.Paragraph};
`;

export const IconWrapper = styled.div`
    margin-right: 8px;
`;
